<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-02-18 16:26:48
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-16 10:44:54
 * @FilePath: \zhucai_user\src\pages\exam\result.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mb50">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="container mb10 mt10"
    >
      <el-breadcrumb-item>订单结果</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="container" v-loading="isLoading">
      <div class="pad30 result">
        <div class="result-img"></div>
        <div class="top-center flex1">
          <p class="content">
            <span
              >订单编号：<span class="val">{{ detail.OrdersNo }}</span>
            </span>
            <span class="ml50"
              >支付金额：<span class="val">{{ detail.Amount }}</span></span
            >
          </p>
          <el-button
            type="primary"
            class="hand"
            @click="hanldDetail()"
            v-loading="isLoading"
            >查看订单</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetMyOrdersDetail } from "@/api/member";
export default {
  name: "Exam_result",
  data() {
    return {
      detail: {},
      isLoading: false,
    };
  },
  watch: {
    "$route.query.UEID"() {
      this.getDetail();
    },
  },

  methods: {
    getDetail() {
      this.isLoading = true;
      GetMyOrdersDetail({ OrdersID: this.$route.query.OrdersID })
        .then((res) => {
          this.detail = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    hanldDetail(data) {
      this.$router.push({
        path: "/member/order",
      });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style lang="scss" scoped>
.red {
  background: #ffe6e8;
  border-radius: 4px;
  text-align: center;
  color: #eb525c;
  width: 57px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #eb525c;
    color: white;
  }
}
.top-left {
  width: 70px;
  height: 70px;
  margin-right: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
.result {
  height: 571px;
  background: #ffffff;
  border-radius: 10px;
  text-align: center;
  .hand {
    margin-top: 100px;
    width: 144px;
    height: 52px;
    background: #1d79ff;
    border-radius: 6px;
    font-size: 18px;
    color: #ffffff;
  }
  .content {
    margin-top: 50px;
    text-align: center;
    font-size: 18px;
    color: #666666;
    .val {
      color: #333333;
    }
  }
  .result-img {
    margin: 50px auto;
    margin-bottom: 20px;
    width: 188px;
    height: 151px;
    background: url("~@/assets/img/home/65.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
